import React from 'react';

/**
 * TemplateCard - Displays a single template in the library
 *
 * Features:
 * - Preview area (placeholder or thumbnail image)
 * - Template name and description
 * - Hover state with scale/shadow effect
 * - Selected state with blue border
 */
const TemplateCard = ({ template, onSelect, isSelected }) => {
  return (
    <div
      onClick={() => onSelect(template)}
      className={`
        group cursor-pointer rounded-lg border-2 overflow-hidden
        transition-all duration-200 ease-in-out
        hover:shadow-lg hover:scale-[1.02]
        ${isSelected
          ? 'border-blue-500 shadow-md'
          : 'border-gray-200 hover:border-gray-300'
        }
      `}
    >
      {/* Preview Area */}
      <div
        className="h-40 flex items-center justify-center overflow-hidden"
        style={{ backgroundColor: '#f5f5f5' }}
      >
        {template.thumbnail ? (
          <img
            src={template.thumbnail}
            alt={template.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="text-gray-400 text-sm font-medium">Preview</span>
        )}
      </div>

      {/* Template Info */}
      <div className="p-3 bg-white">
        <h3
          className="font-semibold text-sm mb-1 truncate"
          style={{ color: '#1a1a1a' }}
        >
          {template.name}
        </h3>
        {template.description && (
          <p
            className="text-xs leading-relaxed line-clamp-2"
            style={{ color: '#666666' }}
          >
            {template.description}
          </p>
        )}
      </div>
    </div>
  );
};

export default TemplateCard;
